import { UserStatuses } from 'globals/constants'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AuthSliceSelector } from 'store/slices'
import { CancelledMessage } from './cancelled-message/CancelledMessage'
import { DashBoardGettingStartedDialog } from './getting-started/DashBoardGettingStartedDialog'
import { OldBasicMembershipMessage } from './old-basic-message/OldBasicMembershipMessage'
import { OldCancelledMessage } from './old-cancelled-message/OldCancelledMessage'
import { PausedMessage } from './paused-message/PausedMessage'
import { PaymentFailedMessage } from './payment-failed/PaymentFailedMessage'
import { TrialEndedMessage } from './trial-ended/TrialEndedMessage'

export const DashBoard = () => {
  const { CurrentUser } = useSelector(AuthSliceSelector)

  const renderComp = useMemo(() => {
    if (CurrentUser?.Status === UserStatuses.OLD_CANCELLED_USER) {
      return <OldCancelledMessage />
    } else if (CurrentUser?.Status === UserStatuses.CANCELLED_USER) {
      return <CancelledMessage />
    } else if (CurrentUser?.Status === UserStatuses.TRIAL_ENDED) {
      return <TrialEndedMessage />
    } else if (CurrentUser?.Status === UserStatuses.OLD_STANDARD_USER) {
      return <OldBasicMembershipMessage />
    } else if (CurrentUser?.Status === UserStatuses.PAUSED_USER) {
      return <PausedMessage />
    } else if (CurrentUser?.Status === UserStatuses.PAYMENT_DECLINED) {
      return <PaymentFailedMessage />
    } else if (CurrentUser?.Status != null && CurrentUser?.Status !== UserStatuses.COMPLETED) {
      return <DashBoardGettingStartedDialog />
    }
    return <></>
  }, [])
  return <>{renderComp}</>
}
